import SiteMap from "./site-map";

export default async function siteMap(element, config = {}) {
    const {
        scene = "/objects/map.json",
        hoverAnimations = {},
        hoverLinks = {},
    } = config;

    const map = new SiteMap(element);

    await map.loadScene(scene);
    await map.start();

    map.setHoverAnimations(hoverAnimations);
    map.setHoverLinks(hoverLinks);

    return map;
}
